import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarGoogleLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 51,
	viewBox: "0 0 52 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i_25024_41938)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.47342 32.2499C5.65856 36.5554 5.75114 38.7081 6.64799 40.3447C7.43734 41.785 8.6509 42.9475 10.1239 43.6743C11.7974 44.5 13.9521 44.5 18.2616 44.5H34.177C38.5062 44.5 40.6708 44.5 42.3488 43.6689C43.8255 42.9376 45.0404 41.768 45.8273 40.32C46.7214 38.6748 46.8036 36.5117 46.9678 32.1857L47.4886 18.4718C47.6668 13.7804 47.7558 11.4347 46.8938 9.64494C46.1361 8.07172 44.8845 6.78961 43.33 5.99428C41.5614 5.08946 39.2143 5.12207 34.52 5.1873L17.5042 5.42372C12.9052 5.48763 10.6056 5.51958 8.88196 6.44752C7.36639 7.26343 6.15438 8.54641 5.42592 10.1059C4.59745 11.8795 4.69625 14.1772 4.89386 18.7724L5.47342 32.2499Z",
				fill: "black",
				fillOpacity: .01
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_i_25024_41938)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M34.177 44.2H18.2616C16.102 44.2 14.5 44.1998 13.2283 44.0977C11.9601 43.996 11.0454 43.7944 10.2566 43.4052C8.83888 42.7058 7.67082 41.5869 6.91107 40.2005C6.48836 39.4292 6.24768 38.524 6.09155 37.2613C5.93497 35.9951 5.86592 34.3946 5.77314 32.237L5.19358 18.7595C5.09456 16.4569 5.02132 14.7481 5.07488 13.3929C5.1283 12.0411 5.30748 11.0683 5.69773 10.2329C6.39887 8.73185 7.56543 7.49699 9.02417 6.71167C9.83611 6.27457 10.7971 6.04039 12.1437 5.91022C13.4937 5.77972 15.2038 5.75572 17.5084 5.7237L34.5242 5.48727C36.8764 5.45459 38.6221 5.43058 40.0014 5.52631C41.3773 5.6218 42.3604 5.83522 43.1933 6.26136C44.6896 7.02686 45.8943 8.26089 46.6236 9.77512C47.0295 10.618 47.2192 11.606 47.2816 12.9838C47.3441 14.365 47.2781 16.1097 47.1888 18.4604L46.668 32.1743C46.5857 34.3422 46.5244 35.9504 46.3733 37.2228C46.2227 38.4916 45.9851 39.4013 45.5637 40.1768C44.8063 41.5704 43.637 42.6961 42.2156 43.4001C41.4247 43.7918 40.5067 43.9947 39.233 44.0971C37.9558 44.1998 36.3465 44.2 34.177 44.2ZM6.64799 40.3447C5.75114 38.7081 5.65856 36.5554 5.47342 32.2499L4.89386 18.7724C4.69625 14.1772 4.59745 11.8795 5.42592 10.1059C6.15438 8.54641 7.36639 7.26343 8.88196 6.44752C10.6056 5.51958 12.9052 5.48763 17.5042 5.42372L34.52 5.1873C39.2143 5.12207 41.5614 5.08946 43.33 5.99428C44.8845 6.78961 46.1361 8.07172 46.8938 9.64494C47.7558 11.4347 47.6668 13.7804 47.4886 18.4718L46.9678 32.1857C46.8036 36.5117 46.7214 38.6748 45.8273 40.32C45.0404 41.768 43.8255 42.9376 42.3488 43.6689C40.6708 44.5 38.5062 44.5 34.177 44.5H18.2616C13.9521 44.5 11.7974 44.5 10.1239 43.6743C8.6509 42.9475 7.43734 41.785 6.64799 40.3447Z",
				fill: "black",
				fillOpacity: .12
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_ddd_25024_41938)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4 16.8C4 12.3196 4 10.0794 4.87195 8.36808C5.63893 6.86278 6.86278 5.63893 8.36808 4.87195C10.0794 4 12.3196 4 16.8 4H35.2C39.6804 4 41.9206 4 43.6319 4.87195C45.1372 5.63893 46.3611 6.86278 47.1281 8.36808C48 10.0794 48 12.3196 48 16.8V29.2C48 33.6804 48 35.9206 47.1281 37.6319C46.3611 39.1372 45.1372 40.3611 43.6319 41.1281C41.9206 42 39.6804 42 35.2 42H16.8C12.3196 42 10.0794 42 8.36808 41.1281C6.86278 40.3611 5.63893 39.1372 4.87195 37.6319C4 35.9206 4 33.6804 4 29.2V16.8Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_ddd_25024_41938)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M35.2 4.5H16.8C14.5515 4.5 12.8953 4.50039 11.5863 4.60733C10.2832 4.7138 9.36848 4.92338 8.59507 5.31745C7.18386 6.0365 6.0365 7.18386 5.31745 8.59507C4.92338 9.36848 4.7138 10.2832 4.60733 11.5863C4.50039 12.8953 4.5 14.5515 4.5 16.8V29.2C4.5 31.4485 4.50039 33.1047 4.60733 34.4137C4.7138 35.7168 4.92338 36.6315 5.31745 37.4049C6.0365 38.8161 7.18386 39.9635 8.59507 40.6825C9.36848 41.0766 10.2832 41.2862 11.5863 41.3927C12.8953 41.4996 14.5515 41.5 16.8 41.5H35.2C37.4485 41.5 39.1047 41.4996 40.4137 41.3927C41.7168 41.2862 42.6315 41.0766 43.4049 40.6825C44.8161 39.9635 45.9635 38.8161 46.6825 37.4049C47.0766 36.6315 47.2862 35.7168 47.3927 34.4137C47.4996 33.1047 47.5 31.4485 47.5 29.2V16.8C47.5 14.5515 47.4996 12.8953 47.3927 11.5863C47.2862 10.2832 47.0766 9.36848 46.6825 8.59507C45.9635 7.18386 44.8161 6.0365 43.4049 5.31745C42.6315 4.92338 41.7168 4.7138 40.4137 4.60733C39.1047 4.50039 37.4485 4.5 35.2 4.5ZM4.87195 8.36808C4 10.0794 4 12.3196 4 16.8V29.2C4 33.6804 4 35.9206 4.87195 37.6319C5.63893 39.1372 6.86278 40.3611 8.36808 41.1281C10.0794 42 12.3196 42 16.8 42H35.2C39.6804 42 41.9206 42 43.6319 41.1281C45.1372 40.3611 46.3611 39.1372 47.1281 37.6319C48 35.9206 48 33.6804 48 29.2V16.8C48 12.3196 48 10.0794 47.1281 8.36808C46.3611 6.86278 45.1372 5.63893 43.6319 4.87195C41.9206 4 39.6804 4 35.2 4H16.8C12.3196 4 10.0794 4 8.36808 4.87195C6.86278 5.63893 5.63893 6.86278 4.87195 8.36808Z",
				fill: "black",
				fillOpacity: .16,
				shapeRendering: "crispEdges"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 35V16H6V35C6 37.7614 8.23858 40 11 40V42C7.13401 42 4 38.866 4 35Z",
			fill: "#4286F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48 35V16H46V35H48Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 41H42C44.7614 41 47 38.7614 47 36H41V41Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48 35H40V42H42C45.3137 42 48 39.3137 48 36V35ZM45.874 37C45.4299 38.7252 43.8638 40 42 40V37H45.874Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5259 32.4576C19.7889 31.9596 19.2786 31.2325 19 30.2711L20.7109 29.5661C20.8662 30.1577 21.1373 30.6162 21.5243 30.9416C21.9089 31.267 22.3773 31.4272 22.9246 31.4272C23.4842 31.4272 23.9649 31.2571 24.3666 30.9169C24.7682 30.5766 24.9706 30.1427 24.9706 29.6178C24.9706 29.0805 24.7585 28.6415 24.3345 28.3015C23.9106 27.9615 23.3781 27.7912 22.7421 27.7912H21.7536V26.0977H22.6409C23.1882 26.0977 23.6492 25.9499 24.0239 25.6541C24.3986 25.3583 24.586 24.954 24.586 24.4388C24.586 23.9803 24.4183 23.6154 24.0831 23.3418C23.7479 23.0683 23.3238 22.9302 22.8086 22.9302C22.3057 22.9302 21.9063 23.0634 21.6105 23.3321C21.3147 23.6008 21.1002 23.9311 20.9647 24.3205L19.2713 23.6156C19.4955 22.9795 19.9073 22.4175 20.5111 21.9319C21.1152 21.4463 21.8866 21.2021 22.8234 21.2021C23.516 21.2021 24.1397 21.3354 24.692 21.604C25.2441 21.8727 25.678 22.2449 25.9911 22.7182C26.3041 23.1938 26.4594 23.7265 26.4594 24.3179C26.4594 24.9219 26.314 25.4321 26.0231 25.8512C25.7321 26.2703 25.3747 26.5906 24.9507 26.8151V26.9161C25.5103 27.1502 25.9663 27.5077 26.3262 27.9884C26.6837 28.4692 26.8635 29.0436 26.8635 29.7141C26.8635 30.3846 26.6934 30.9836 26.3532 31.5087C26.013 32.0338 25.5422 32.4479 24.9457 32.7486C24.3467 33.0493 23.6738 33.2021 22.9268 33.2021C22.0616 33.2046 21.263 32.9556 20.5259 32.4576Z",
			fill: "#1A73E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.0246 23.9679L29.156 25.3261L28.2168 23.9013L31.5866 21.4707H32.8784V32.9358H31.0246V23.9679Z",
			fill: "#1A73E8"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter4_dd_25024_41938)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4 16C4 12.2725 4 10.4087 4.60896 8.93853C5.42092 6.97831 6.97831 5.42092 8.93853 4.60896C10.4087 4 12.2725 4 16 4H36C39.7275 4 41.5913 4 43.0615 4.60896C45.0217 5.42092 46.5791 6.97831 47.391 8.93853C48 10.4087 48 12.2725 48 16H4Z",
				fill: "#4286F5"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 10,
			r: 2,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34,
			cy: 10,
			r: 2,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 9,
			width: 8,
			height: 2,
			rx: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40 42H11V40H40V42Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_i_25024_41938",
				x: 4.75684,
				y: 3.1582,
				width: 42.8496,
				height: 41.3418,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_25024_41938"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_i_25024_41938",
				x: 4.75684,
				y: 3.1582,
				width: 42.8496,
				height: 41.3418,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_25024_41938"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_ddd_25024_41938",
				x: .533001,
				y: 1.84807,
				width: 51.1731,
				height: 48.6401,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.14072 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.67372 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.478207,
						dy: .71731
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.19552 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_25024_41938",
						result: "effect2_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .119552,
						dy: 1.43462
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.79328 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_25024_41938",
						result: "effect3_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_25024_41938",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_ddd_25024_41938",
				x: .533001,
				y: 1.84807,
				width: 51.1731,
				height: 48.6401,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.14072 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.67372 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.478207,
						dy: .71731
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.19552 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_25024_41938",
						result: "effect2_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .119552,
						dy: 1.43462
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.79328 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_25024_41938",
						result: "effect3_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_25024_41938",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_dd_25024_41938",
				x: 1,
				y: 2,
				width: 50,
				height: 18,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_25024_41938",
						result: "effect2_dropShadow_25024_41938"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_25024_41938",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgCalendarGoogleLight;
